import React from 'react';
import BaseLinearProgress from '@material-ui/core/LinearProgress';

const LinearProgress = (props) => <BaseLinearProgress {...props} />;

export default LinearProgress;
